/**
 * 複写するマニフェスト一覧
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/managements`

 const manifest = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     *
     * @param commit
     * @param conditions { Object }
     * @property search_type { string }
     * @property supplier_type { string }
     * @property supplier_id { number }
     * @property supplier_location_key { string }
     * @property type_of_manifest { string }
     * @property keyword { string }
     * @property start_date { string }
     * @property end_date { string }
     * @property vote_staff { string }
     * @property waste_name { string }
     * @property manifest_search_keyword { string }
     * @property page { number }
     * @return {Promise<unknown>}
     */
    index ({ commit }, { conditions }) {
      const params = {
        ...conditions,
        sort_type: 'updated',
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},

 }

 export default manifest
